import HtmlParser from 'html-react-parser';
import React from 'react';
import Helmet from 'react-helmet';
import ReactPlayer from 'react-player';
import { DemoFormLong } from '../../components/DemoFormLong.jsx';
import JoinHappyCustomers from '../../components/JoinHappyCustomers';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';
import { PATHS } from '../../utils/urls';

const Home = (props) => {

    const location = props.location;

    return (
        <Layout bodyClass="page-integrations" ontouchstart>
            <SEO title="Security | ChartHop | The Org Management Platform" />
            <Helmet>
                <meta
                    name="description"
                    content="Protecting your sensitive data is core to our value. We use cutting-edge mechanisms and procedures to keep your data safe. Our SOC 2 Type 2 proves it."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="Security | ChartHop | The Org Management Platform" />
                <meta property="og:description" content="Protecting your sensitive data is core to our value. We use cutting-edge mechanisms and procedures to keep your data safe. Our SOC 2 Type 2 proves it." />
                <meta property="og:image" content={`https://www.charthop.com/home/security-meta.png`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="Security | ChartHop | The Org Management Platform" />
                <meta name="twitter:description" content="Protecting your sensitive data is core to our value. We use cutting-edge mechanisms and procedures to keep your data safe. Our SOC 2 Type 2 proves it." />
                <meta name="twitter:image" content={`https://www.charthop.com/home/security-meta.png`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
            </Helmet>

            {/* HERO CONTENT */}
            <section className="sectionSpacing">
                <section className="hero-splitSectionSpacing contentBlock">
                    <div>
                        <div className="segmentHalf">
                            <h1 className="mx-auto">Protecting your data is our #1 priority.</h1>
                        </div>
                        <div className="segmentHalf">
                            <div className="reactPlayerContainer" >

                                <ReactPlayer
                                    url="/security/security-header.mp4"
                                    playing
                                    loop
                                    muted
                                    playsinline
                                />
                            </div>
                        </div>
                    </div>
                </section>
            </section>

                
			{/* SECURITY FEATURES */}
            <section className="backgroundGradientContainer-Reverse sectionSpacing flex-centeredColumn">
				<div className="flex-centeredColumn contentBlock">
					<h2 className="text-center">We've built the ChartHop platform security-first.</h2>
                    <p className="text-center">You're entrusting ChartHop with your most valuable data, and we take this responsibility very seriously.</p>
					<div className="svg-info sectionSpacing ">
						<div className="svg-info-card-3col">
							<img src={'/security/access.svg'} alt="Access" />
							<h3>Fine-Grained Controls</h3>
							<p> Control data access with highly customizable, enterprise-grade controls.</p>
						</div>
                        <div className="svg-info-card-3col">
							<img src={'/security/role.svg'} alt="Role" />
							<h3>Role-Based Access</h3>
							<p>Access controls are based on roles, not individuals.</p>
						</div>
                        <div className="svg-info-card-3col">
							<img src={'/security/offboarding.svg'} alt="Offboarding" />
							<h3>Auto On/Offboarding</h3>
							<p>ChartHop invites employees on their first day and revokes access on their last day.</p>
						</div>
                        <div className="svg-info-card-3col ">
							<img src={'/security/encryption.svg'} alt="Encryption" />
							<h3>Full Encryption</h3>
							<p>All data is encrypted at rest and in transit.</p>
						</div>
						<div className="svg-info-card-3col">
							<img src={'/security/biometric.svg'} alt="Biometric" />
							<h3>Biometric Access Control</h3>
							<p> Data can only be accessed with biometric and/or U2F keys.</p>
						</div>
                        <div className="svg-info-card-3col">
							<img src={'/security/sso.svg'} alt="SSO" />
							<h3>Mandatory SSO</h3>
							<p>ChartHop supports multiple SSO and authentication options.</p>
						</div>
					</div>
				</div>
			</section>
      
            {/* SOC 2 */}
            <section className="sectionSpacing">
				<div className="container pt-3 pb-3 pt-md-6 pb-md-6">
					<div className="row align-items-center">

						<div className="col-md-8 col-lg-6 offset-lg-1 ">
							<h2 className="mb-2">Third-party SOC 2 Type 2 Examined. </h2>
                            <p> ChartHop has successfully completed a SOC 2 Type 2 examination by Schellman & Company.</p>
                            <p> The SOC 2 certification is widely recognized as the standard for data security. It requires that companies establish and follow rigorous data security policies and procedures.</p>
							
                            <p>By engaging Schellman, we have gained an objective evaluation of the effectiveness of such controls, particularly as it relates to Security.
                            </p>
                            <a href="/blog/company-updates/charthop-announces-soc2" className="ctaStandard text-center">Learn more </a>
						</div>

						<div className="reactPlayerContainer col-md-4 col-lg-3 offset-lg-1" >
							<img src='/home/bunny_shield.svg' alt="Bunny Shield" className="p-2 d-none d-md-block " />
						</div>
					</div>
				</div>
			</section>
           
                        {/* ACCESS CONTROLS NEW */}
			<section className="backgroundGradientContainer-Reverse sectionSpacing">
                <div className="container pt-3 pb-3 pt-md-6 pb-md-6">
                    <div className="row align-items-center">
                        <div className="col-md-8 col-lg-6 order-md-2 offset-lg-1">
                                    <h2 class="text-right">Robust access controls that serve your every need.</h2>
                                    <p class="text-right">Make data available to those who need it and not visible to those who don't.</p>
                                    <p class="text-right">Tag every data point using a wide range of customizable sensitivity levels - from Org Public to Personal Data to Compensation.</p>
                                    <p class="text-right">Leverage complex managerial and role-based data access. Now, you don't need to make multiple copies of the same spreadsheet for different team members (and no need to fear sending the wrong one, either!).</p> 
                        </div>
                    
                        <div className="reactPlayerContainer col-md-4 col-lg-3 offset-lg-1">
                            <img src='/security/bunny-lock.svg' alt="Bunny Lock" className="p-2 d-none d-md-block " />
                        </div>
                    </div>
             </div>

               

				<div className="flex-centeredColumn contentBlock">
					<div className="svg-info ">
						<div className="svg-info-card-3col">
							<img src={'/security/visibility.svg'} alt="Access" />
							<h3>Feel confident</h3>
							<p> Use the built-in View As feature to verify permissions and visibility for others.</p>
						</div>
                        <div className="svg-info-card-3col">
							<img src={'/security/collaborate.svg'} alt="Role" />
							<h3>Collaborate freely</h3>
							<p>Easily hide sensitive data from your screen using the sensitive data toggle.</p>
						</div>
                        <div className="svg-info-card-3col">
							<img src={'/security/customize.svg'} alt="Offboarding" />
							<h3>Customize as needed</h3>
							<p>Fine-tune access to specific needs (ex: only access comp in NYC except for executives).</p>
						</div>
					</div>
				</div>
			</section>
            {/* COSTUMERS */}
            <section className="customer testimonial-container pt-8 pb-5">
                <JoinHappyCustomers title={HtmlParser('Trusted <span class="blue-text">by</span>')}></JoinHappyCustomers>								
			</section> 
            {/* SSO */}
            <section className="flex-centeredColumn sectionSpacing backgroundGradientContainer-Reverse">
                <div className="favouriteIntegrationsContent sectionSpacing">
                <h2 className="text-center">SSO Partners</h2> 
                    <p className="text-center">We work with the systems you use and trust.</p>

                    <div className="floating-minorCardContainer">
                        {/* FIRST 4 */}

                        <div>
                            <div>
                                <img src='/integrations/logos/logo-okta.png' alt="Okta" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-googlesso@2x.jpg' alt="Google SSO" />
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src='/integrations/logos/logo-microsoftsso@2x.jpg' alt="Microsoft SSO" />
                            </div>
                        </div>
                    </div>
                </div> 
                <div className="d-flex flex-column sectionSpacing">
					<a href={PATHS.INTEGRATIONS} className="ctaStandard text-center smallMobile">Check out more integrations </a>
				</div>
            </section>

            {/* LONG FORM */}
            <section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
                <DemoFormLong source={"product-security-demo-bottom"} headertext={HtmlParser("<h2>See it in action! </br> </br> Request a demo.</h2>")}/>
            </section>            
        </Layout>
    );
};


export default Home;
